import { useContext, useEffect, useState } from 'react'
import { AppContext } from '@state/context'

const useFilteredItems = (items, filterState) => {
  const [state] = useContext(AppContext)
  const [filteredItems, setFilteredItems] = useState([])
  const {
    schoolYearFilter,
    subjectFilter,
    levelFilter,
  } = filterState ?? state?.filters

  useEffect(()=> {
    if (!items){
      setFilteredItems([])
      return
    } 

    const filtered = items.filter((item) => {
      const {
        schoolYear: { id: schoolYearId },
        subject: { id: subjectId },
        level: { id: levelId },
      } = item

      let allowed = true

      if (subjectFilter) {
        allowed = subjectFilter === subjectId
      }

      if (allowed && schoolYearFilter) {
        allowed = schoolYearFilter === schoolYearId
      }

      if (allowed && levelFilter) {
        allowed = levelFilter === levelId
      }

      return allowed
    })

    setFilteredItems(filtered)
  }, [items?.length, subjectFilter, schoolYearFilter, levelFilter])

  return filteredItems
}

export { useFilteredItems }
